import styled from 'styled-components';

export const StyledChatHistoryWrapper = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing['2Xl']}`};
  h4 {
    margin: ${({ theme }) => `0 0 ${theme.spacing['xl']} 0`};
    padding: 0;
  }
`;

export const StyledDivider = styled.div`
  background-color: ${({ theme }) => theme.border.weak};
  margin: ${({ theme }) => `${theme.spacing['2Xl']} 0`};
  min-height: ${({ theme }) => theme.border['xs']};
`;

export const StyledHistoryItem = styled.div`
  display: flex;
  border: ${({ theme }) => `${theme.border['xs']} solid ${theme.border.weak}`};
  border-radius: ${({ theme }) => theme.borderRadius['md']};
  padding: ${({ theme }) => `${theme.spacing['lg']} ${theme.spacing['md']}`};
  :hover {
    cursor: pointer;
    border-color: transparent;
    box-shadow: ${({ theme }) => `0 0 0 ${theme.border['sm']} ${theme.border.default}`};
  }
`;

export const StyledHistoryLeftContent = styled.div`
  display: grid;
  place-content: center;
  margin-right: ${({ theme }) => theme.spacing.md};
  svg {
    color: ${({ theme }) => theme.brand.primary};
    height: ${({ theme }) => theme.spacing['3Xl']};
    width: ${({ theme }) => theme.spacing['3Xl']};
  }
`;

export const StyledHistoryRightContent = styled.div`
  display: grid;
  place-content: center;
`;
